import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {
  EmployeePay,
  ManualCheck,
  MasterPayrollObject,
  OpenPaylineDetailsArgs,
  SelectedPaylineArgs,
  SharedPayrollInfo,
  TimeClockSelection
} from '../models/payroll';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  // NOTE: this service is intended for communication between two unrelated components
  public addPayline: Subject<SelectedPaylineArgs>;
  public addPersonToPayroll: Subject<EmployeePay>;
  public closeMoreActionsPopup: Subject<void>;
  public focusPayline: Subject<number>; // personId
  public openPaylineDetails: Subject<OpenPaylineDetailsArgs>;
  public openAddPersonToPayrollModal: Subject<number[]>; // personIds already in payroll
  public openPayrollPersonModal: Subject<number>; // personId

  // fires when changes are saved in the people editor.
  // payroll grid listens to detect if user saved person edits while in payroll
  public personEditsSaved: Subject<void>;

  // TASK 13575
  public manualChecks: ManualCheck[];

  // TASK 13012
  public timeclockSelection: TimeClockSelection;

  // TASK 9739
  public payrollStatusInfo: SharedPayrollInfo = null;

  constructor() {
    this.addPayline = new Subject<SelectedPaylineArgs>();
    this.addPersonToPayroll = new Subject<EmployeePay>();
    this.closeMoreActionsPopup = new Subject<void>();
    this.focusPayline = new Subject<number>();
    this.openAddPersonToPayrollModal = new Subject<number[]>();
    this.openPaylineDetails = new Subject<OpenPaylineDetailsArgs>();
    this.openPayrollPersonModal = new Subject<number>();
    this.personEditsSaved = new Subject<void>();
  }

  // task 9742
  public getPayrollStatusInfo() {
    const info = sessionStorage.getItem('payrollStatusInfo');
    if (info) {
      return JSON.parse(info);
    } else {
      return null;
    }
  }

  public setPayrollStatusInfo(payroll: MasterPayrollObject) {
    if (payroll) {
      const info = {
        ClientCode: payroll.ClientCode,
        CalendarId: payroll.Calendars[0],
        LocationId: payroll.LocationId,
        PayDate: payroll.PayDate,
        SequenceNumber: payroll.SequenceNumber,
        Status: payroll.Status,
        Year: payroll.Year
      };
      sessionStorage.setItem('payrollStatusInfo', JSON.stringify(info));
    } else {
      sessionStorage.removeItem('payrollStatusInfo');
    }
  }
}
